import React, { useEffect } from "react";
import { socket } from "../../services/socket";
import {
  consumeRemoteStream,
  groupConsumersByUser,
} from "../../services/mediasoup-client";
import { useMediasoupClient } from "../../hooks/useMediasoupClient";
import { useMeeting } from "../../hooks/useMeeting";

export default function MainMeetingContainer({ children }) {
  const { recvTransport } = useMediasoupClient();
  const { participants, setParticipants } = useMeeting();

  useEffect(function () {
    socket.emit("give_me_existing_consumers", null, async (consumers) => {
      for (const consumer of groupConsumersByUser(consumers)) {
        await consumeRemoteStream(consumer, recvTransport, setParticipants);
      }
    });
  }, []);

  return (
    <div
      className={`${
        participants.length > 1 ? "container-fluid" : "container"
      } mon-composant-meet-video-content-container`}
      style={{ marginTop: "calc(var(--appbar-height, 73px) + 12px)" }}
    >
      {children}
    </div>
  );
}
